/**
 * Staff activity / audit logs (UI mock).
 */

export const ACTIVITY_MODULES = [
  'Staff',
  'Villagers',
  'Vendors',
  'Equipment',
  'Indents',
  'Master Data',
  'Auth',
];

export const ACTIVITY_ACTION_TYPES = [
  { value: 'LOGIN', label: 'Login' },
  { value: 'CREATE', label: 'Create' },
  { value: 'UPDATE', label: 'Update' },
  { value: 'DELETE', label: 'Delete' },
  { value: 'KYC', label: 'KYC / Verification' },
  { value: 'PASSWORD', label: 'Password' },
  { value: 'RECOMMEND', label: 'Recommend' },
  { value: 'DEPLOY', label: 'Deployment' },
  { value: 'DOCUMENT', label: 'Documents' },
];

export const staffActivitySeed = [
  {
    logId: 'LOG-001',
    staffId: 'STF-001',
    staffName: 'Priya Sharma',
    actionType: 'LOGIN',
    module: 'Auth',
    summary: 'Signed in to admin panel',
    entityType: '',
    entityId: '',
    at: '2026-08-12T09:15:00',
  },
  {
    logId: 'LOG-002',
    staffId: 'STF-002',
    staffName: 'Rahul Mehta',
    actionType: 'KYC',
    module: 'Vendors',
    summary: 'Verified vendor VND-001 — Mundra Earth Movers',
    entityType: 'vendor',
    entityId: 'VND-001',
    at: '2026-08-12T10:05:00',
  },
  {
    logId: 'LOG-003',
    staffId: 'STF-002',
    staffName: 'Rahul Mehta',
    actionType: 'KYC',
    module: 'Equipment',
    summary: 'Updated KYC for AST-003 — WATER TANKER (Pending)',
    entityType: 'asset',
    entityId: 'AST-003',
    at: '2026-08-12T10:22:00',
  },
  {
    logId: 'LOG-004',
    staffId: 'STF-004',
    staffName: 'Vikram Patel',
    actionType: 'RECOMMEND',
    module: 'Indents',
    summary: 'Recommended 3 vehicles on IND-001',
    entityType: 'indent',
    entityId: 'IND-001',
    at: '2026-08-12T11:00:00',
  },
  {
    logId: 'LOG-005',
    staffId: 'STF-004',
    staffName: 'Vikram Patel',
    actionType: 'DEPLOY',
    module: 'Indents',
    summary: 'Assigned AST-V001 to IND-002',
    entityType: 'indent',
    entityId: 'IND-002',
    at: '2026-08-12T11:45:00',
  },
  {
    logId: 'LOG-006',
    staffId: 'STF-003',
    staffName: 'Kavita Jadeja',
    actionType: 'UPDATE',
    module: 'Vendors',
    summary: 'Edited vendor VND-002 — Kutch Hire Services',
    entityType: 'vendor',
    entityId: 'VND-002',
    at: '2026-08-11T15:30:00',
  },
  {
    logId: 'LOG-007',
    staffId: 'STF-005',
    staffName: 'Anita Desai',
    actionType: 'UPDATE',
    module: 'Master Data',
    summary: 'Updated village V-MUN-059 — Mundra',
    entityType: 'village',
    entityId: 'V-MUN-059',
    at: '2026-08-11T14:00:00',
  },
  {
    logId: 'LOG-008',
    staffId: 'STF-001',
    staffName: 'Priya Sharma',
    actionType: 'CREATE',
    module: 'Staff',
    summary: 'Created staff user STF-006',
    entityType: 'staff',
    entityId: 'STF-006',
    at: '2026-08-10T09:00:00',
  },
  {
    logId: 'LOG-009',
    staffId: 'STF-001',
    staffName: 'Priya Sharma',
    actionType: 'PASSWORD',
    module: 'Staff',
    summary: 'Reset password for STF-004 — Vikram Patel',
    entityType: 'staff',
    entityId: 'STF-004',
    at: '2026-08-09T16:20:00',
  },
  {
    logId: 'LOG-010',
    staffId: 'STF-002',
    staffName: 'Rahul Mehta',
    actionType: 'DOCUMENT',
    module: 'Equipment',
    summary: 'Added PUC document on AST-003',
    entityType: 'asset',
    entityId: 'AST-003',
    at: '2026-08-08T12:10:00',
  },
];
